import { FileTemplateExport, IcoDownloadCloudArrowSmall } from '@icons';
import { downloadEmptyTemplate } from '@lib/api_ts/salTemplatesApi';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface SalTemplateDownloadProps {}

const SalTemplateDownload: React.FC<SalTemplateDownloadProps> = () => {
	const [isModalOpen, setIsModalOpen] = React.useState(false);

	const templateToDownload = [
		{
			label: 'Costi esterni',
			name: 'invoices',
			description:
				'Per fatture verso fornitori. Include: NOME PROGETTO, CUP/ID PROGETTO, ID FATTURA, POSIZIONE, CODICE IMPIANTO, CENTRO DI COSTO, ID QUOTA, RIF. ESTRAZIONE ed IMPORTO QUOTA.',
		},
		{
			label: 'Costi interni',
			name: 'timesheets',
			description:
				'Per costi del personale. Include: CUP/ID PROGETTO, WP/STREAM, NR. RECORD, ANNO, MESE, GIORNO, MATRICOLA, WBE, ORDINE, CATEGORIA e COSTO SUL PROGETTO.',
		},
	] as const;

	const downloadEmptyTemplateMutation = useMutation({
		mutationFn: (templateName: 'invoices' | 'timesheets') => {
			return downloadEmptyTemplate(templateName);
		},
	});
	return (
		<>
			<Button
				className="btn custom-ghost-button"
				onClick={() => {
					setIsModalOpen(true);
				}}
				style={{
					display: 'flex',
					gap: '0.5rem',
					alignItems: 'center',
					height: '39px',
				}}
			>
				<IcoDownloadCloudArrowSmall /> scarica template
			</Button>
			<Modal
				show={isModalOpen}
				onHide={() => {
					setIsModalOpen(false);
				}}
				centered
				size="xl"
				className="custom-modal-xl"
			>
				<Modal.Header
					style={{
						justifyContent: 'center',
						padding: '1.5rem',
					}}
				>
					<Modal.Title
						style={{
							display: 'grid',
							gap: '1rem',
							justifyItems: 'center',
						}}
					>
						<FileTemplateExport
							style={{
								fill: 'var(--np-primary-color)',
							}}
						/>
						<h5
							style={{
								fontSize: '24px',
								fontWeight: 700,
								marginBottom: 0,
							}}
						>
							Scarica Template
						</h5>
						<p
							style={{
								fontSize: '18px',
								fontWeight: 400,
								marginBottom: 0,
								textAlign: 'center',
								textWrap: 'balance',
							}}
						>
							Scarica il template di cui hai bisogno per effettuare il caricamento e leggi le istruzioni per compilare correttamente i file
							scaricati.
						</p>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ display: 'grid', gap: '1rem' }}>
					{templateToDownload.map((template) => (
						<div
							key={template.name}
							style={{
								borderRadius: '8px',
								padding: '1rem',
								border: '1px solid #2A3A64',
								display: 'grid',
								gap: '3em',
								gridTemplateColumns: '1fr auto',
							}}
						>
							<div style={{ display: 'grid', gap: '0.5rem' }}>
								<p
									style={{
										marginBottom: 0,
										fontWeight: 700,
									}}
								>
									Template {template.label}
								</p>
								<p
									style={{
										marginBottom: 0,
									}}
								>
									{template.description}
								</p>
							</div>
							<div
								style={{
									display: 'grid',
									placeContent: 'center',
								}}
							>
								<Button
									onClick={() => {
										downloadEmptyTemplateMutation.mutate(template.name);
									}}
									style={{
										display: 'flex',
										gap: '0.5rem',
										alignItems: 'center',
										height: '39px',
									}}
								>
									<IcoDownloadCloudArrowSmall /> Scarica
								</Button>
							</div>
						</div>
					))}
					<div style={{ padding: '1rem', backgroundColor: 'var(--np-secondary-color--ultralight)', borderRadius: '8px' }}>
						<p
							style={{
								marginBottom: '.5rem',
								fontWeight: 700,
							}}
						>
							Come compilare i template
						</p>
						<ul style={{ paddingLeft: '1.5rem' }}>
							<li>Non modificare l'ordine o i nomi delle colonne</li>
							<li>
								Le date devono essere nel formato{' '}
								<span
									style={{
										paddingInline: '.5rem',
										backgroundColor: '#fff',
										borderRadius: '8px',
									}}
								>
									GG/MM/AAAA
								</span>
							</li>
							<li>Verifica che le voci siano eleggibili prima di procedere</li>
							<li>Rinomina ogni foglio con il numero del SAL corrispondente</li>
						</ul>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						className="btn custom-outline-button"
						style={{
							height: '48px',
						}}
						onClick={() => {
							setIsModalOpen(false);
						}}
					>
						Chiudi
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default SalTemplateDownload;
